import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ZigZagHeadingAndCtaModel extends BaseModel {
  variables?: { [key: string]: string } | ZigZagHeadingAndCtaVariables;
}

export interface ZigZagHeadingAndCtaVariables {
  ZigZagHacHeading: string;
  ZigZagHacImage: string;
  ZigZagHacImageHref: string;
  ZigZagHacImageAlt: string;
  ZigZagHacCtaLink: string;
  ZigZagHacCtaText: string;
  ZigZagHacText: string;
  ZigZagHacImageHrefSegmentRegex: string;
  ZigZagHacCtaLinkSegmentRegex: string;
}

export class ZigZagHeadingAndCtaInitVariables implements ZigZagHeadingAndCtaVariables {
  ZigZagHacHeading = '';
  ZigZagHacImage = '';
  ZigZagHacImageHref = '';
  ZigZagHacImageAlt = '';
  ZigZagHacCtaLink = '';
  ZigZagHacCtaText = '';
  ZigZagHacText = '';
  ZigZagHacImageHrefSegmentRegex = '';
  ZigZagHacCtaLinkSegmentRegex = '';
}

export class ZigZagHeadingAndCtaInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ZigZagHeadingAndCtaInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
